export default __webpack_public_path__ + "static/app-screen-1-347efd423c9d5ed9c446a8dd5abd1a66.png";